<template>
  <div>
    <transition name="fade">
      <div :class="[ 'overlay' ]" v-if="open" v-on:click="close"></div>
    </transition>
    <transition name="slide">
      <div class="body loading" v-if="open && isLoading">
        <span class="spinner-border spinner-border" role="status"></span>
      </div>
      <div class="body" v-else-if="open">
        <div class="title">
          <button class="btn" v-on:click="close">
            <img src="../assets/icons/back.svg" alt="Back" />
          </button>
          Upcoming this month
        </div>
        <div class="events">
          <div v-for="(event, i) in events" :key="event.id">
            <div class="date" v-if="isDifferentDate(i)">{{ getPrettyDate(event.date) }}</div>
            <router-link :to="getLink(event)" class="row event">
              <div class="col-md-3">
                <Calendar :date="event.date" />
              </div>
              <div class="col-md-9 text-col">
                <div class="title">{{ event.title }}</div>
                <div class="text">{{ event.subTitle }}</div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="bottom">
          <div class="row">
            <div class="col-sm-6">
              <router-link to="/tours" class="btn btn-red btn-block">View All Tours</router-link>
            </div>
            <div class="col-sm-6">
              <router-link to="/alerts" class="btn btn-red btn-block">View All Alerts</router-link>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import Calendar from "./Calendar.vue";

export default {
  name: 'UpcomingEvents',
  components: {
    Calendar,
  },
  props: [ 'open', 'close' ],
  data: function () {
    return {
      isLoading: true,
      events: [],
    };
  },
  watch: {
    open: function(newVal) {
      if (newVal === true) {
        this.events = [];
        this.isLoading = true;
        axios.get('/api/dashboard/metrics/upcoming-events/read')
          .then((response) => {
            this.isLoading = false;
            if (response.data.events) {
              this.events = response.data.events;
            }
          });
      }
    }
  },
  methods: {
    getPrettyDate: function(dateStr) {
      let date = new Date(dateStr);
      return date.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    },
    isDifferentDate: function(index) {
      if (index === 0) {
        return true;
      }

      for(let i = 0; i < this.events.length; i++) {
        if (i === index) {
          let thisDate = new Date(this.events[i].date);
          let lastDate = new Date(this.events[i - 1].date);
          let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
          return thisDate.toLocaleString('en-US', options) != lastDate.toLocaleString('en-US', options);
        }
      }

      return true;
    },
    getLink: function (event) {
      if (event.type == 'alert') {
        return `/alerts/${event.id}`;
      }
      else if (event.type == 'tour') {
        return `/tours/${event.id}`;
      }
      else {
        return `/tours`;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables";

div.overlay {
  background: rgba(black, 0.5);
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

div.body {
  position: fixed;
  z-index: 11;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100vh;
  background: white;
  width: 550px;
  overflow-y: auto;
  padding: 60px 27px 0;

  &.loading {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  > div.title {
    color: #4A4A4A;
    font-weight: 500;
    font-size: 1.25rem;
    line-height: 1.2;
    position: relative;
    padding-left: 1rem;
    margin: 0 0 57px;

    button {
      position: absolute;
      right: calc(100% - 1rem);
      padding: 0 10px;
    }
  }

  div.bottom {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 550px;
    padding: 28px 57px;
    background-color: white;
    box-shadow: -1px -1px 40px 0 rgba(0,0,0,0.13);
  }
}

div.date {
  background-color: #F4F4F3;
  font-size: 0.75rem;
  color: #848484;
  line-height: 1.66;
  padding: 4px 30px;
  min-height: 33px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0 0 2rem;
}

div.date + a.event div.text-col {
  &:before {
    display: none;
  }
}

div.events {
  padding-bottom: 100px;
  > div {
    &:last-child {
      a.event {
        div.text-col {
          &:before {
            display: none;
          }
        }
      }
    }
  }
  a.event {
    padding-bottom: 0.75rem;
    margin-bottom: 0.75rem;
    position: relative;
    margin-left: 0;
    margin-right: 0;

    &:hover {
      text-decoration: none;

      &:after {
        right: -5px;
      }

      div.title {
        color: var(--accentColor);
      }
    }

    &:after {
      content: "";
      position: absolute;
      right: 15px;
      top: calc(50% - 4.325px);
      background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='5px' height='10px' viewBox='0 0 5 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3EPath%3C/title%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Dashboard' transform='translate(-1342.000000, -212.000000)'%3E%3Cg id='Group-9' transform='translate(912.000000, 125.000000)'%3E%3C/g%3E%3Cpolygon id='Path' fill='%23000000' transform='translate(1344.453982, 217.046018) rotate(-90.000000) translate(-1344.453982, -217.046018) ' points='1348.07999 214.546018 1344.45398 218.344242 1340.80799 214.565703 1340.12874 215.234994 1344.44399 219.546018 1348.77922 215.215309'%3E%3C/polygon%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      height: 8.65px;
      width: 5px;
      transition: right 250ms;
    }

    div.text-col {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      position: relative;

      &:before {
        content: "";
        display: block;
        position: absolute;
        bottom: -0.75rem;
        left: 15px;
        right: 15px;
        height: 1px;
        background-color: #EBEBEB;
      }
    }

    div.title {
      font-size: 1rem;
      color: #4A4A4A;
      line-height: calc(18 / 16);
      margin: 0 0 2px;
      transition: color 250ms;
    }

    div.text {
      font-size: 0.75rem;
      line-height: 2;
      color: rgba(#222222, 0.56);
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;  
      overflow: hidden;
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .25s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.slide-enter-active, .slide-leave-active {
  transition: transform .25s;
}
.slide-enter, .slide-leave-to {
  transform: translateX(550px);
}
</style>
